import {Stack} from '@mui/material';
import React from 'react';

import saludiaLogo from 'presentation/assets/images/saludia-logo.svg';
import {useMediaQueries} from 'presentation/pages/private/hooks';

import {Drawer} from '../../../Drawer';
import {StyledSaludiaIcon} from './styles';
import {SaludiaDrawerProps} from './types';

export function SaludiaDrawer({
	open,
	title,
	buttonTitle,
	description,
	compactOnMobile,
	onClose,
	onConfirm,
	children,
}: SaludiaDrawerProps) {
	const {isMobile} = useMediaQueries();
	const isCompact = isMobile && !!compactOnMobile;

	return (
		<Drawer.Root
			open={open}
			onClose={onClose}
			onOpen={() => undefined}
			disableSwipeToOpen
			width="400px"
			height={isMobile ? 'auto' : '100%'}>
			<Drawer.Header
				title={title}
				onClose={onClose}
				fontSize={isCompact ? '16px' : undefined}
				fontWeight={isCompact ? 400 : undefined}
				lineHeight={isCompact ? '24px' : undefined}
			/>
			<Drawer.Content flex={1}>
				<Stack gap={isCompact ? '14px' : 2}>
					<Stack
						direction={isCompact ? 'row' : 'column'}
						alignItems={isCompact ? compactOnMobile?.iconAlign : 'flex-start'}
						gap={isCompact ? compactOnMobile?.gap : 2}>
						<StyledSaludiaIcon $compact={isCompact}>
							<img src={saludiaLogo} alt="" />
						</StyledSaludiaIcon>
						{description}
					</Stack>
					{children}
				</Stack>
			</Drawer.Content>
			<Drawer.Footer
				hideDivider={!isCompact}
				hideFirstButton
				secondButtonTitle={buttonTitle}
				secondButtonOnClick={onConfirm}
			/>
		</Drawer.Root>
	);
}
